module.exports = __webpack_public_path__ + "img/stone5.0388cda8.png";